import React from 'react';
import UserSymbol from '../UserSymbol';
import { getUserType } from '../../helpers';
export var BasicUserName = function (_a) {
    var user = _a.user, _b = _a.showSymbol, showSymbol = _b === void 0 ? true : _b, symbolOpensPopup = _a.symbolOpensPopup, symbolClassName = _a.symbolClassName, usernameClassName = _a.usernameClassName;
    return (React.createElement(React.Fragment, null,
        usernameClassName ? (React.createElement("span", { className: usernameClassName }, user.username)) : (user.username),
        showSymbol && (React.createElement(UserSymbol, { userType: getUserType(user), className: symbolClassName, openUserSymbolPopup: symbolOpensPopup }))));
};
BasicUserName.displayName = 'BasicUserName';
export default BasicUserName;
//# sourceMappingURL=BasicUserName.js.map